@if (disclaimer) {
  <div class="flex flex--center pr-medium" [ngClass]="containerClasses">
    @if (disclaimer.iconUrl || disclaimer.svgIcon) {
      <div class="flex--nogrow heather-700-text font-body-1">
        @if (disclaimer.iconUrl) {
          <img [src]="disclaimer.iconUrl" [alt]="disclaimer.teaserTitle" />
        }
        @if (disclaimer.svgIcon) {
          <fcom-icon [name]="disclaimer.svgIcon" class="ps-medium-r nordic-blue-900-text icon-medium" />
        }
      </div>
    }
    @if (disclaimer.target; as target) {
      <div class="flex-1 font-body-1">
        <a class="nordic-blue-900-text font-body-1" [finLink]="target.url" [external]="target.external">{{
          target.teaserTitle
        }}</a>
      </div>
    } @else {
      <div class="disclaimer-content flex-1 font-body-1" [innerHTML]="disclaimer.teaserText | finSafe: 'html'"></div>
    }
  </div>
}
